import mutations from "./mutations"
import actions from "./actions"

export default {
  state () {
    return{
      wastes: ""
    }
  },
  mutations: mutations,
  actions: actions,
}